import React from "react";
import { Lang } from "../../types/common-types";
import AccountForm from "../../types/account-form.types";
import { actions, Dispatch, State } from "../../state-actions-reducers";
import { INSTANCE } from "../../server-parameters";
import styles from './Footer.module.scss'
import Button from "../../shared/Buttons/Button";
import ArrowRightImg from '../../images/long-arrow-right.svg'
import ArrowWhite from '../../images/long-arrow-right_white.svg'
import InfoImg from '../../images/info.svg'

interface FooterProps {
    lang: Lang
    parentUrl: string
    accountForm: AccountForm
    state: State
    dispatch: Dispatch
    step: number
    totalSteps: number
    activeForm: 'Physical' | 'Company' | 'Individual'
    handleResetState: () => void
    setStrictValidation: (e: boolean) => void
    invalidFields: string[]
    setInvalidFields: (e: string[]) => void
    setNextStep: (e: boolean) => void
}
export const profileType_Physical = 'Physical'
export const profileType_Fiscal = 'Fiscal'

export default function Footer({ lang, parentUrl, accountForm, state, dispatch, step, totalSteps, activeForm, handleResetState, setStrictValidation, invalidFields, setInvalidFields, setNextStep }: FooterProps) {
    return <>
        <div className="row">
            {step == 0 ? (
                <div className={styles.FooterButtonBox + ' ' + 'col-12'}>
                    <div>
                        <Button
                            bg={'accent'}
                            value={accountForm.agreementButtonConfurm[lang]}
                            onClick={() => {
                                state.agreed = true
                                state.profileType = activeForm === 'Physical' ?
                                    profileType_Physical : profileType_Fiscal;
                                state.F_FiscalType = activeForm === 'Company' ? '2' : activeForm === 'Individual' ? '1' : ''
                                dispatch({
                                    type: actions.AGREE_ON_AGREEMENT,
                                    data: true,
                                })
                            }}
                            borderDiagonal='right'
                            rightIcon={<img src={INSTANCE === 'second' ? ArrowRightImg : ArrowWhite} alt="arrow-right" />}
                            animationIcon="right"
                        ></Button>
                        <Button
                            tag={'link'}
                            bg={'hollow'}
                            value={accountForm.moreAboutForm[lang]}
                            url={`${parentUrl}info/client-form/about`}
                            borderDiagonal='right'
                            leftIcon={<img src={InfoImg} alt="infoImg" />}
                        ></Button>
                    </div>
                </div>
            ) : null}
            {/* PREV BUTTON */}
            <div className={styles.FooterButtonBox + ' ' + 'col-12'}>
                {step < totalSteps && step !== 0 ? (
                    <Button
                        bg={'hollow'}
                        border='noBorder'
                        uppercase={true}
                        testName={step === 1 ? 'cancelButton' : 'prevButton'}
                        value={
                            step === 1
                                ? accountForm.cancelButton[lang]
                                : accountForm.prevButton[lang]
                        }
                        onClick={() => {
                            if (step === 1) {
                                handleResetState()
                            } else {
                                // Turn off strict validation
                                setStrictValidation(false)
                                // Reset invalid fields
                                setInvalidFields([])
                                // Move to prev step
                                dispatch({
                                    type: actions.CURRENT_STEP,
                                    data: state.currentStep - 1,
                                })
                            }
                        }}
                    ></Button>
                ) : null}
                {/* NEXT BUTTON */}
                {step < totalSteps - 1 && step !== 0 ? (
                    <div>
                        <span>{accountForm.requiredDesc[lang]}</span>
                        <Button
                            bg={'accent'}
                            testName="nextButton"
                            value={accountForm.nextButton[lang]}
                            disabled={
                                step > totalSteps ||
                                invalidFields.length !== 0 || !state.isIdentityOk || state.imageError.length !== 0 || state.serverError
                            }
                            onClick={() => setNextStep(true)}
                        ></Button>
                    </div>
                ) : null}
                {step === totalSteps - 1 ? (
                    <div>
                        <Button
                            testName="submitButton"
                            value={accountForm.submitButton[lang]}
                            onClick={() => {
                                if (window.parentIFrame) window.parentIFrame.sendMessage({
                                    clickSubmit: true
                                })
                                setNextStep(true)
                            }}
                        ></Button>
                    </div>
                ) : null}
            </div>
        </div>
        <div className="row">
            {step <= totalSteps &&
                step !== 0 &&
                state.profileType == profileType_Fiscal ? (
                <div className="col-12">
                    <div className={styles.Footer}>
                        {INSTANCE === 'ala' ?
                            lang === 'eng' ? (
                                <>
                                    <p className={styles.troubleMessage}>
                                        If you have any difficulty completing the form,{' '}
                                        <span>contact us by email </span>
                                        <a href="mailto:i@kino.rent">
                                            i@kino.rent
                                        </a>
                                        <span> or by phone </span>
                                        <a href="tel:+77003571338">+7 (700) 357-13-38</a>
                                    </p>
                                    <p className={styles.additionalTroubleMessage}>
                                        Additional phone number:
                                        <a href="tel:+77073571338">+7 (707) 357-13-38</a>
                                    </p>
                                </>
                            ) : lang === 'kz' ? (
                                <>
                                    <p className={styles.troubleMessage}>
                                        Пішінді толтыруда қиындықтар туындаса,{' '}
                                        <span>электрондық пошта арқылы хабарласыңыз </span>
                                        <a href="mailto:i@kino.rent">
                                            i@kino.rent
                                        </a>
                                        <span> немесе телефон арқылы </span>
                                        <br />
                                        <a href="tel:+77073571338">+7 (700) 357-13-38</a>
                                    </p>
                                    <p className={styles.additionalTroubleMessage}>
                                        Қосымша телефон нөмірі:
                                        <a href="tel:+77073571338">+7 (707) 357-13-38</a>
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className={styles.troubleMessage}>
                                        Если у Вас возникли трудности при заполнении анкеты,{' '}
                                        <span>свяжитесь по эл. почте </span>
                                        <a href="mailto:i@kino.rent">
                                            i@kino.rent
                                        </a>
                                        <span> или по телефону </span>
                                        <a href="tel:+77003571338">+7 (700) 357-13-38</a>
                                    </p>
                                    <p className={styles.additionalTroubleMessage}>
                                        Дополнительный номер телефона:
                                        <a href="tel:+77073571338">+7 (707) 357-13-38</a>
                                    </p>
                                </>
                            )
                            : INSTANCE === 'msk' || INSTANCE === 'spb' ?
                                lang === 'eng' ? (
                                    <>
                                        <p className={styles.troubleMessage}>
                                            If you have any difficulty completing the form,{' '}
                                            <span>contact us by email </span>
                                            <a href="mailto:op@kino.rent">
                                                op@kino.rent
                                            </a>
                                            <span> or by phone </span>
                                            <a href="tel:+74992888385">+7 (499) 288-83-85</a>
                                        </p>
                                        <p className={styles.additionalTroubleMessage}>
                                            Additional phone number:
                                            <a href="tel:+77273467181">+7 (985) 043-48-40</a>
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <p className={styles.troubleMessage}>
                                            Если у Вас возникли трудности при заполнении анкеты,{' '}
                                            <span>свяжитесь по эл. почте </span>
                                            <a href="mailto:op@kino.rent">
                                                op@kino.rent
                                            </a>
                                            <span> или по телефону </span>
                                            <a href="tel:+74992888385">+7 (499) 288-83-85</a>
                                        </p>
                                        <p className={styles.additionalTroubleMessage}>
                                            Дополнительный номер телефона:
                                            <a href="tel:+79850434840">+7 (985) 043-48-40</a>
                                        </p>
                                    </>
                                ) : lang === 'eng' ? (
                                    <>
                                        <p className={styles.troubleMessage}>
                                            If you have any difficulty completing the form,{' '}
                                            <span>contact us by email </span>
                                            <a href="mailto:rent@scnd.rent">
                                                rent@scnd.rent
                                            </a>
                                            <span> or by phone </span>
                                            <a href="tel:+79917792163">+7 (991) 779-21-63</a>
                                        </p>
                                        {/* <p className={styles.additionalTroubleMessage}>
                  Additional phone number:
                  <a href="tel:+77273467181">+7 (985) 043-48-40</a>
                </p> */}
                                    </>
                                ) : (
                                    <>
                                        <p className={styles.troubleMessage}>
                                            Если у Вас возникли трудности при заполнении анкеты,{' '}
                                            <span>свяжитесь по эл. почте </span>
                                            <a href="mailto:rent@scnd.rent">
                                                rent@scnd.rent
                                            </a>
                                            <span> или по телефону </span>
                                            <a href="tel:+79917792163">+7 (991) 779-21-63</a>
                                        </p>
                                        {/* <p className={styles.additionalTroubleMessage}>
                  Дополнительный номер телефона:
                  <a href="tel:+79850434840">+7 (985) 043-48-40</a>
                </p> */}
                                    </>
                                )
                        }
                    </div>
                </div>
            ) : null}
        </div>
    </>
}